import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { Tab } from 'src/components/sticky-tab-nav/types';
import {
  MainTabId,
  PropertiesTabId,
  ReviewsTabId,
  StatisticsTabId,
} from '../product-tabs/constants';
import { ProductNavigationLink } from './styles';

export const useNavigationLinks = (): Tab[] => {
  const { t } = useContext(AppContext);
  return [
    {
      id: MainTabId,
      title: (
        <ProductNavigationLink data-test="TabButton" data-test-section="main">
          {t('product', 'tabs.prices')}
        </ProductNavigationLink>
      ),
      scrollToTop: true,
    },
    {
      id: ReviewsTabId,
      title: (
        <ProductNavigationLink
          data-test="TabButton"
          data-test-section="reviews"
        >
          {t('product', 'tabs.reviews')}
        </ProductNavigationLink>
      ),
    },
    {
      id: StatisticsTabId,
      title: (
        <ProductNavigationLink
          data-test="TabButton"
          data-test-section="statistics"
        >
          {t('product', 'tabs.price-history')}
        </ProductNavigationLink>
      ),
    },
    {
      id: PropertiesTabId,
      title: (
        <ProductNavigationLink
          data-test="TabButton"
          data-test-section="properties"
        >
          {t('product', 'tabs.properties')}
        </ProductNavigationLink>
      ),
    },
  ];
};
